export const LogoMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <path d="M8 27V14a8 8 0 0 1 16 0v13" fill="none" stroke="#C5A059" strokeWidth="1.8" />
    <path d="M16 9.5l1.3 3.7 3.7 1.3-3.7 1.3-1.3 3.7-1.3-3.7-3.7-1.3 3.7-1.3z" fill="#E2D1B3" />
    <path d="M5 27h22" stroke="#C5A059" strokeWidth="1.8" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3" dir="ltr">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-['Playfair_Display'] text-xl tracking-[0.18em] text-[var(--paper)]">STRAVION</span>
      <span className="block font-['JetBrains_Mono'] text-[10px] tracking-[0.42em] text-[var(--gold)] mt-1">ADVISORY FZE</span>
    </span>
  </span>
);
